import {useSelector,useDispatch} from 'react-redux'
import {
	getEventDetails,
	getEventTypeKey,
	selectUserEvents,
} from '../state/events'
import useCurrentUser from '../hooks/useCurrentUser'

export const useEvent = (type,id,includeItems=false) => {
	const dispatch = useDispatch()
	const event = useSelector( 
		state => (Boolean(id)&&Boolean(type))&&state.allEvents[getEventTypeKey(type)].entities[id]
	)
	// trigger fetch details if needed this should only ever happen if 
	// the event was opened and then edited which causes getEvents to 
	// be be dispatched. getEvents will update all 
	if (event&&(event.showDetails||includeItems)&&!event.hasDetails&&!event.detailsPending) {
		dispatch(getEventDetails({
			event_type:type,
			event_id:id,
		}))
	}
	return event
}//end useEvent => useSelector

export const useFavoriteEvents = (type) => {
	const user = useCurrentUser()
	const events = useSelector(
		state => selectUserEvents( state, type, user.user_id_number )
	)
	return events
}























